import APIConfig from '../apiconfig';

export const shouldShowLogin = () => {
  return APIConfig.showLogin;
};

export default shouldShowLogin;
